import { render } from "./BreathRate.vue?vue&type=template&id=4560c5dd&scoped=true&ts=true"
import script from "./BreathRate.vue?vue&type=script&lang=ts"
export * from "./BreathRate.vue?vue&type=script&lang=ts"

import "./BreathRate.vue?vue&type=style&index=0&id=4560c5dd&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4560c5dd"]])

export default __exports__